export const QUERY_KEY_GROUPS = 'groups';
export const QUERY_KEY_MAP_GROUPS = 'groups-map';
export const QUERY_KEY_RELATED_GROUPS_BY_GROUP_MULTI_ID = 'related-groups-by-group-muilti-id';
export const QUERY_KEY_DEVICES_BY_GROUP = 'devices-by-group';
